import { copyToClipboard } from '@/utils';
import DoneIcon from '@mui/icons-material/Done';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import Link from 'next/link';
import { Stack, SxProps, Theme, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WalletAddressHighlighter from '@/components/ui/WalletAddressHighlighter';

const Wrapper = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.bg.secondary,
  display: 'inline-flex',
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  border: theme.palette.border.normal,
  width: '100%',
  cursor: 'pointer',
  alignItems: 'center',
  wordBreak: 'break-all',
  ...theme.typography.body2,
  color: theme.palette.grey[400],
  fontSize: '13px',
  ['&:hover']: {
    backgroundColor: theme.palette.grey[900],
  },
}));

/**
 *
 * @param variant
 * @param children
 * @param text
 * @param iconOnly
 * @param sxs
 * @param title
 * @constructor
 */
const CopyTextField = ({
  variant = 'text',
  children,
  text,
  iconOnly,
  sxs = {
    iconSX: {},
    wrapperSX: {},
  },
  title,
  transactionAnchor = null,
}: {
  variant?: 'text' | 'wallet-address';
  children?: React.ReactNode;
  text: string;
  iconOnly?: boolean;
  sxs?: {
    iconSX?: SxProps<Theme>;
    wrapperSX?: SxProps<Theme>;
  };
  title?: string;
  transactionAnchor?: {
    text: string;
    href: string;
  } | null;
}) => {
  const [copySuccess, setCopySuccess] = useState(false);

  const onClick = () => {
    copyToClipboard(text).then(() => {
      setCopySuccess(true);
      toast.success('Copied');
      setTimeout(() => {
        setCopySuccess(false);
      }, 1000);
    });
  };

  const iconSX = {
    color: 'primary.main',
  };

  const icon = !copySuccess ? (
    <ContentCopyIcon
      sx={{
        cursor: 'pointer',
        ...iconSX,
        ...sxs.iconSX,
        flexBasis: 'auto',
        color: (theme) => theme.palette.primary.main,
      }}
      fontSize={'small'}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    />
  ) : (
    <DoneIcon
      sx={{
        color: 'success.main',
        ...sxs.iconSX,
      }}
      fontSize={'small'}
    ></DoneIcon>
  );

  const content = iconOnly ? (
    icon
  ) : (
    <Wrapper onClick={onClick} sx={sxs.wrapperSX} direction={'row'} gap={1}>
      <Stack direction={'row'} alignItems={'center'} flexGrow={'1'}>
        {variant === 'wallet-address' ? (
          <WalletAddressHighlighter address={text} />
        ) : (
          children
        )}
      </Stack>
      {icon}
    </Wrapper>
  );
  return title && !iconOnly ? (
    <Stack gap={0.5}>
      <Stack direction={'row'} alignItems={'center'}>
        <Typography>{title}</Typography>
        {transactionAnchor ? (
          <Typography sx={{ ml: 1, cursor: 'pointer', color: 'primary.main' }}>
            <Link target="blank" href={transactionAnchor.href}>
              {transactionAnchor.text}
            </Link>
          </Typography>
        ) : (
          <></>
        )}
      </Stack>
      {content}
    </Stack>
  ) : (
    content
  );
};
export default CopyTextField;
